// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Off-the-Shelf catalog page — a richer take on the nf-core card grid. */

.ots-page-container {
  padding: 40px 48px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
  min-height: 100vh;
  font-family: "Inter", sans-serif;
  color: #1e293b;
}

/* Header */
.ots-header h2 {
  font-size: 32px;
  font-weight: 800;
  margin: 0 0 10px;
  background: linear-gradient(90deg, #2563eb, #7c3aed);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.5px;
}

.ots-header h4 {
  font-size: 16px;
  font-weight: 500;
  color: #475569;
  margin: 0 0 32px;
  max-width: 720px;
  line-height: 1.5;
}

.ots-loading {
  color: #64748b;
  font-size: 15px;
}

/* Empty state */
.ots-empty {
  margin-top: 60px;
  text-align: center;
  color: #64748b;
}
.ots-empty-icon { font-size: 48px; }
.ots-empty-title { font-size: 20px; font-weight: 700; color: #334155; margin-top: 12px; }
.ots-empty-sub { font-size: 14px; margin-top: 6px; }

/* Card grid */
.ots-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 28px;
}

/* Category card */
.ots-card {
  position: relative;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  padding: 26px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 10px 30px rgba(30, 41, 59, 0.08);
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
  overflow: hidden;
}

/* Accent bar along the top of each card */
.ots-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #2563eb, #7c3aed);
}

.ots-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 42px rgba(37, 99, 235, 0.18);
  border-color: #c7d2fe;
}

.ots-card-head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ots-card-icon {
  font-size: 28px;
  line-height: 1;
}

.ots-card-title {
  font-weight: 800;
  font-size: 19px;
  color: #0f172a;
  letter-spacing: 0.2px;
}

.ots-card-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
}

/* Pipeline buttons */
.ots-pipeline-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
}

.ots-pipeline-btn {
  background: linear-gradient(90deg, #2563eb, #4f46e5);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 11px 14px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.25);
}

.ots-pipeline-btn:hover {
  filter: brightness(1.05);
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.35);
}

/* Coming Soon placeholder (category with no released pipelines yet) */
.ots-coming-soon {
  padding: 14px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #94a3b8;
  text-align: center;
  background: #f1f5f9;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
}

/* Responsive */
@media (max-width: 1024px) {
  .ots-grid {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }
}

@media (max-width: 640px) {
  .ots-page-container {
    padding: 24px 18px;
  }
  .ots-header h2 {
    font-size: 26px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/OffTheShelf.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA,kBAAkB,eAAe,EAAE;AACnC,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACxF,iBAAiB,eAAe,EAAE,eAAe,EAAE;;AAEnD,cAAc;AACd;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8CAA8C;EAC9C,gFAAgF;EAChF,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0EAA0E;EAC1E,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Off-the-Shelf catalog page — a richer take on the nf-core card grid. */\n\n.ots-page-container {\n  padding: 40px 48px;\n  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);\n  min-height: 100vh;\n  font-family: \"Inter\", sans-serif;\n  color: #1e293b;\n}\n\n/* Header */\n.ots-header h2 {\n  font-size: 32px;\n  font-weight: 800;\n  margin: 0 0 10px;\n  background: linear-gradient(90deg, #2563eb, #7c3aed);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  letter-spacing: -0.5px;\n}\n\n.ots-header h4 {\n  font-size: 16px;\n  font-weight: 500;\n  color: #475569;\n  margin: 0 0 32px;\n  max-width: 720px;\n  line-height: 1.5;\n}\n\n.ots-loading {\n  color: #64748b;\n  font-size: 15px;\n}\n\n/* Empty state */\n.ots-empty {\n  margin-top: 60px;\n  text-align: center;\n  color: #64748b;\n}\n.ots-empty-icon { font-size: 48px; }\n.ots-empty-title { font-size: 20px; font-weight: 700; color: #334155; margin-top: 12px; }\n.ots-empty-sub { font-size: 14px; margin-top: 6px; }\n\n/* Card grid */\n.ots-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 28px;\n}\n\n/* Category card */\n.ots-card {\n  position: relative;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 18px;\n  padding: 26px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-shadow: 0 10px 30px rgba(30, 41, 59, 0.08);\n  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;\n  overflow: hidden;\n}\n\n/* Accent bar along the top of each card */\n.ots-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  background: linear-gradient(90deg, #2563eb, #7c3aed);\n}\n\n.ots-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 18px 42px rgba(37, 99, 235, 0.18);\n  border-color: #c7d2fe;\n}\n\n.ots-card-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.ots-card-icon {\n  font-size: 28px;\n  line-height: 1;\n}\n\n.ots-card-title {\n  font-weight: 800;\n  font-size: 19px;\n  color: #0f172a;\n  letter-spacing: 0.2px;\n}\n\n.ots-card-desc {\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n/* Pipeline buttons */\n.ots-pipeline-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.ots-pipeline-btn {\n  background: linear-gradient(90deg, #2563eb, #4f46e5);\n  color: #ffffff;\n  border: none;\n  border-radius: 12px;\n  padding: 11px 14px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: left;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;\n  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.25);\n}\n\n.ots-pipeline-btn:hover {\n  filter: brightness(1.05);\n  transform: translateY(-2px);\n  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.35);\n}\n\n/* Coming Soon placeholder (category with no released pipelines yet) */\n.ots-coming-soon {\n  padding: 14px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: #94a3b8;\n  text-align: center;\n  background: #f1f5f9;\n  border: 1px dashed #cbd5e1;\n  border-radius: 12px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .ots-grid {\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .ots-page-container {\n    padding: 24px 18px;\n  }\n  .ots-header h2 {\n    font-size: 26px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
